// extracted by mini-css-extract-plugin
export default {"overlay":"Spinner__overlay__Ezg3V","card":"Spinner__card__ZczGd","progress":"Spinner__progress__cmGZA","count":"Spinner__count__rrquX"};